import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import ImageCarousel from './Section/ImageCarousel';

export default function EmbeddedMedia({ data, fit }) {
  return (
    <>
      {data.images?.length === 1 && !data.embeddedCodeSnippet
        ? data.images.map((image) => (
            <GatsbyImage
              key={image.id}
              alt={image.description || image.title || ''}
              image={image.gatsbyImageData}
              objectFit={fit}
            />
          ))
        : null}
      {data.images?.length > 1 && !data.embeddedCodeSnippet ? (
        <ImageCarousel images={data.images} fit={fit} />
      ) : null}
      {data.image && !data.embeddedCodeSnippet ? (
        <GatsbyImage
          key={data.image.id}
          alt={data.image.description || data.image.title || ''}
          image={data.image.gatsbyImageData}
          objectFit={fit}
        />
      ) : null}

      {data.embeddedCodeSnippet ? (
        <div
          className="embedded-media"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: data.embeddedCodeSnippet.embeddedCodeSnippet,
          }}
        />
      ) : null}
    </>
  );
}
